import { render } from "./NoticeSingle.vue?vue&type=template&id=07586256&scoped=true"
import script from "./NoticeSingle.vue?vue&type=script&lang=js"
export * from "./NoticeSingle.vue?vue&type=script&lang=js"

import "./NoticeSingle.vue?vue&type=style&index=0&id=07586256&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07586256"]])

export default __exports__